export enum TasSortField {
  NAME = 'name',
  CATEGORY = 'category',
  CREATED_AT = 'createdAt',
}
